import axios from "axios";
import { clientVitalsAPI } from "../secrets";
import { AuthUser } from "src/context/AuthContext";

export const putUser = async (
    user: Record<any, any>
) => {
    try {
        const result = await axios.post(`${clientVitalsAPI}/dynamo/users/add-or-update`, { user });

        return result
    } catch (error) {
        throw error;
    }
};

export const putMAP = async (
    map: Record<any, any>
) => {
    try {
        const result = await axios.post(`${clientVitalsAPI}/dynamo/maps/add-or-update`, { map });

        return result
    } catch (error) {
        throw error;
    }
};